import {DesignSystem, DesignSystemStaticSizes} from '../../../engine/_interfaces/designSystem';
import process from '../../../engine/design-system/layout/static-sizes-to-placeholders';

const params: DesignSystemStaticSizes = {
  'pre-header': {
    _desc: 'PreHeader component fixed dimensions',
    height: {
      tablet: 111,
    },
  },
  'site-header': {
    _desc: 'SiteHeader component fixed dimensions',
    height: {
      mobile: 76,
    },
  },
  'contact-tools': {
    _desc: 'ContactTools component fixed dimensions',
    height: {
      mobile: 64,
    },
  },
  'in-view': {
    _desc: 'offest trigger distance for on element entering in viewport',
    offset: {
      mobile: 100,
    },
  },
  'button-chat--tiny': {
    _desc: 'ButtonChat component fixed dimensions',
    width: {
      mobile: 64,
    },
  },
};

const designSystem: DesignSystem = {
  _EXPORT: process,
  _NAME: 'Static Sizes',
  params,
};

export default designSystem;
